import { createContext, useContext } from 'react';

/** Words the shared components say on their own. The app passes its language through `UiTextProvider`. */
export interface UiText {
  balance: string;
  history: string;
  monthlySpend: string;
  runway: string;
  topUp: string;
  copy: string;
  copied: string;
  sections: string;
  amount: string;
  domainAvailable: string;
  domainTaken: string;
  domainPremium: string;
  priceOnRequest: string;
  renewPerYear: (price: string) => string;
  serverState: Record<'ok' | 'busy' | 'provisioning' | 'off' | 'error', string>;
}

export const UI_TEXT_RU: UiText = {
  balance: 'Баланс',
  history: 'История',
  monthlySpend: 'Расход в месяц',
  runway: 'Хватит',
  topUp: 'Пополнить',
  copy: 'Копировать',
  copied: 'Скопировано',
  sections: 'Разделы',
  amount: 'Сумма',
  domainAvailable: 'Свободен',
  domainTaken: 'Занят',
  domainPremium: 'Премиум',
  priceOnRequest: 'по запросу',
  renewPerYear: (price) => `продление ${price} / год`,
  serverState: {
    ok: 'Работает',
    busy: 'Высокая нагрузка',
    error: 'Недоступен',
    off: 'Выключен',
    provisioning: 'Создаётся',
  },
};

const Ctx = createContext<UiText>(UI_TEXT_RU);
export const UiTextProvider = Ctx.Provider;
export const useUiText = () => useContext(Ctx);
